import {
    Autocomplete,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, InputLabel, MenuItem, Select,
    TextField
} from "@mui/material";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useSnackbar} from "notistack";
import {MenuProps} from "../../Utils/PropsStyles";
import Box from "@mui/material/Box";
import {SelectChangeEvent} from "@mui/material/Select";
import ConfirmDialog from "./ConfirmDialog";
interface ParamsModalProps {
    open: boolean;
    onCloseModal: any;
    commandDTOList: Array<CommandDTO>;
}
export interface CommandDTO {
    id: number;
    teleObjectName: string;
    userId: number;
    point: number;
    teleObjectSpecType: number;
    etsCode: number;
    brokerId: number;
    powerStationName?: string;
    skidName?: string | null;
    equipmentName?: string;
    commandValues?: any;
    confirmation?: boolean;
}
export const SendingTelecommandUnifilar = ({open, onCloseModal, commandDTOList}: ParamsModalProps) => {
    const { enqueueSnackbar } = useSnackbar();

    const getInitialCommandValue = (commandDTO: CommandDTO | null) => {
        return commandDTO != null && commandDTO.commandValues.length === 1 ? commandDTO.commandValues[0].value : ""
    }

    const getInitialCommand = (commandDTO: CommandDTO | null) => {
        return commandDTO != null && commandDTO.commandValues.length === 1 ? commandDTO.commandValues[0].name as string : ""
    }

    const getInitialCommandId = (commandDTO: CommandDTO | null) => {
        return commandDTO != null && commandDTO.commandValues.length === 1 ? commandDTO.commandValues[0].id : null
    }


    const [inputValue, setInputValue] = useState("");
    const [commandDTO, setCommandDTO] = useState<CommandDTO | null>(null)
    const cardInfo = commandDTOList != null && commandDTOList.length > 0 ? commandDTOList[0] : null
    const [selectedCommand, setSelectedCommand] = useState("");
    const [selectCommandId, setSelectCommandId] = useState(null);
    const [commandConfirm, setCommandConfirm] = useState(false);


    useEffect(() => {
        setInputValue("")
        setCommandConfirm(false)
    }, [onCloseModal]);

    const handleButtonClick = (_:any, data:CommandDTO) => {
        setCommandDTO(data);
    }

    useEffect(() => {
        setInputValue(getInitialCommandValue(commandDTO))
        setSelectedCommand(getInitialCommand(commandDTO))
        setSelectCommandId(getInitialCommandId(commandDTO))
    }, [commandDTO]);


    const handleSelectTeleCommandValue = (event: SelectChangeEvent<unknown>) => {
        setSelectedCommand(event.target.value as string);
        let commandValue = commandDTO?.commandValues.find((cmd: any) => cmd.name === event.target.value);
        if (commandValue != null) {
            setInputValue(commandValue.value);
            setSelectCommandId(commandValue.id);
        }
    }

    const handleSend = async () => {
        if (commandDTO != null && inputValue != null) {
            if (!/^\d+$/.test(inputValue)) {
                enqueueSnackbar("Apenas valores numéricos são aceitos!", {variant: "error"});
                handleCloseCommandConfirm()
                return;
            }
            if(commandDTO.teleObjectSpecType === 5 && Number(inputValue) > 1){
                enqueueSnackbar("Apenas os valores 0 e 1 são aceitos!", {variant: "error"});
                handleCloseCommandConfirm()
                return;
            }
            axios.post('/api/send-command', {
                userId: commandDTO.userId,
                teleObjectId: commandDTO.id,
                point: commandDTO.point,
                teleObjectSpecType: commandDTO.teleObjectSpecType,
                etsCode: commandDTO.etsCode,
                data: Number(inputValue),
                brokerId: commandDTO.brokerId,
                commandValueId: selectCommandId

            }).then(
                () => {
                    enqueueSnackbar("Comando enviado com sucesso!", { variant: "success" });
                    setSelectCommandId(null);
                    setSelectedCommand("");
                }
            ).catch(
                error => {
                    // @ts-ignore
                    enqueueSnackbar(`Erro ao enviar o comando: ${error.response.data.detail}`, {variant: "error"});
                    console.error("Erro ao enviar comando. Tente novamente:", error);
                }
            )
            onCloseModal()
            handleCloseCommandConfirm()
        }
    };
    const printFullHeader = () => {
        if(cardInfo != null){
            if(cardInfo?.skidName != null && cardInfo?.powerStationName != null && cardInfo?.equipmentName != null){
                return true
            }
        }
        return false
    }

    const sendCommand = async () => {
        if(commandDTO?.confirmation === false){
            handleSend()
        }
        setCommandConfirm(commandDTO?.confirmation ?? true)
    }

    const handleCommandConfirm = async ( ) => {
        handleSend();
    }

    const handleCloseCommandConfirm = async ( ) => {
        setCommandConfirm(false)
    }

    return (
        <Dialog
            PaperProps={{
                sx: (theme) => ({
                    width: '50%', // largura padrão para telas pequenas
                    maxWidth: '600px', // limite superior para telas grandes
                    [theme.breakpoints.up('sm')]: {
                        width: '30%',
                    },
                    [theme.breakpoints.up('md')]: {
                        width: '25%',
                    },
                    [theme.breakpoints.up('lg')]: {
                        width: '25%',
                    },
                    [theme.breakpoints.up('xl')]: {
                        width: '15%',
                    },
                }),
            }}
            open={open}
            onClose={onCloseModal}>

            {printFullHeader() ?
                <DialogTitle>{cardInfo?.equipmentName + ' - ' + cardInfo?.skidName + ' - ' + cardInfo?.powerStationName+ ' teste'}</DialogTitle>
                :   <DialogTitle>{cardInfo?.teleObjectName + ' teste'}</DialogTitle>
            }
            <DialogContent aria-label={"telecommand-modal"}>
                <Autocomplete
                    id="grouped-demo"
                    value={commandDTO}
                    fullWidth
                    options={commandDTOList}
                    getOptionLabel={(option) => option.teleObjectName}
                    inputValue={commandDTO?.teleObjectName ?? ''}
                    renderInput={(params) => <TextField {...params} label={"Comandos"} variant="standard" />}
                    onChange={(event: any, newValue: any) => handleButtonClick(event,newValue)}
                    sx={{paddingBottom: 3}}
                />
                {
                       (commandDTO?.commandValues && commandDTO?.commandValues.length > 0) ?
                            <Box>
                                <InputLabel id="valueCommand" sx={{fontSize: '.8rem'}}>Selecione o Valor</InputLabel>
                                <Select
                                    fullWidth
                                    labelId="valueCommand"
                                    id="valueCommand"
                                    placeholder="Selecione o valor"
                                    value={selectedCommand}
                                    label="Selecione o valor"
                                    title="Selecione o valor"
                                    onChange={(value) => handleSelectTeleCommandValue(value)}
                                    variant={"standard"}
                                    MenuProps={MenuProps}
                                >
                                    {commandDTO.commandValues.map((item: any, index: number) =>
                                        <MenuItem
                                            sx={{
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word',
                                                maxWidth: '100%',
                                            }}
                                            key={index}
                                            value={item.name}>{`Nome: ${item.name}, Valor: ${item.value}`}</MenuItem>)}
                                </Select>
                            </Box>
                            :
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Digite o valor"
                                type="text"
                                fullWidth
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                            />
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseModal} color="primary">
                    Cancelar
                </Button>
                <Button onClick={sendCommand} color="primary" variant="contained" disabled={inputValue === ""}>
                    Enviar
                </Button>
                <ConfirmDialog
                    title={'Enviar'}
                    description={'Deseja enviar esse comando?'}
                    open={commandConfirm}
                    handleConfirm={handleCommandConfirm}
                    handleClose={handleCloseCommandConfirm}

                />
            </DialogActions>
        </Dialog>
    )
}